var adManager = require('src/interlock/product/ads/index.js').adManager;
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var debounce = require('throttle-debounce/debounce');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones.js');
var JAN1_2017_EPOCH_TIME = 1483228800000;

var getDataObj = function(data, name){
    return data ? (data[name] || {}) : {};
};

function processAds(dataObj, adsSection) {
    adsSection && adsSection.enable_retarget ?
        adManager.retargetAllAdUnits(adsSection.retarget_exclude_special_case) :
        adManager.refreshAdUnitsByZone(REFRESH_ZONES.ENGAGEMENT,  dataObj);
}

function checkTimeStamp(eventTs) {
    var timestamp = eventTs;
    if (eventTs < JAN1_2017_EPOCH_TIME) {
        // for cases where browsers use DOMHighResTimeStamp for event timestamp,
        // we need to add back epoch time from when user lands on page
        timestamp = (window.performance && window.performance.timing && window.performance.timing.navigationStart) ?
            Math.round(window.performance.timing.navigationStart + eventTs) :
            Date.now();
    }
    return timestamp;
}

$(document).on('action', function (event, data) {
    if(!data.ads || !data.ads.disable_refresh){
        var dataObj = getDataObj(data, 'data');
        dataObj.ts = (dataObj.ts || event.timeStamp) + '';
        var event_dataObj = getDataObj(data, 'event_data');
        adManager.setModuleLoaded(event_dataObj.creative_id);
        // debounce will only allow one ad refresh per 100ms timeframe
        // this helps prevent engagements that trigger two actions simultaneously
        // from triggering two ad refreshes.
        var atBegin = true;
        var refreshAds = debounce(100, atBegin, function() {
            processAds(dataObj, data.ads);
            eventToolbox.fireAction({
                'event_type': 'action_completed',
                'ads': {
                    'disable_refresh': 'true'
                },
                'ts': dataObj.ts + '',
                'event_data': {
                    'action_category': 'system',
                    'action_name': 'ad_load',
                    'action_cause': event_dataObj.action_cause || 'action_completed',
                    'action_tsp': dataObj.ts + '',
                    'creative_id': event_dataObj.creative_id
                }
            });
        });
        refreshAds();
    }
});

var carouselZoneRefreshed = false;
$('.owl-carousel').on('drag.owl.carousel next.owl.carousel prev.owl.carousel to.owl.carousel', function (event) {
    if(!carouselZoneRefreshed) {
        carouselZoneRefreshed = true;
        var containingCreative = $(event.target).closest('.edm-entry');
        var dataObj = {};
        dataObj.ts = event.timeStamp + '';
        adManager.setModuleLoaded(containingCreative.attr('id'));
        adManager.refreshAdUnitsByZone(REFRESH_ZONES.CAROUSEL, dataObj);
        eventToolbox.fireAction({
            'event_type': 'action_completed',
            'ads': {
                'disable_refresh': 'false'
            },
            'ts': dataObj.ts + '',
            'event_data': {
                'action_category': 'system',
                'action_name': 'ad_load',
                'action_cause': 'action_completed',
                'action_tsp': dataObj.ts + '',
                'creative_id': containingCreative.attr('id')
            }
        });

        // prevents additional carousel-related ad refreshes from occurring within 100ms of the previous
        setTimeout(function(){ carouselZoneRefreshed = false; }, 100);
    }
});

var globalNavZoneRefreshed = false;
$('.global-nav').on('click', function (event, data) {
    var targetElement = event.target;

    if(!globalNavZoneRefreshed && ($(targetElement).data('show') || !targetElement.href)) {
        globalNavZoneRefreshed = true;
        var containingCreative = $(event.target).closest('.edm-entry');
        var dataObj = getDataObj(data, 'data');
        dataObj.ts = (dataObj.ts || checkTimeStamp(event.timeStamp)) + '';
        adManager.setModuleLoaded(containingCreative.attr('id'));
        adManager.refreshAdUnitsByZone(REFRESH_ZONES.GLOBAL_NAV, dataObj);
        eventToolbox.fireAction({
            'event_type': 'action_completed',
            'ads': {
                'disable_refresh': 'true'
            },
            'ts': dataObj.ts + '',
            'event_data': {
                'action_category': 'system',
                'action_name': 'ad_load',
                'action_cause': 'action_completed',
                'action_tsp': dataObj.ts + '',
                'creative_id': containingCreative.attr('id')
            }
        });

        // prevents additional global-nav-related ad refreshes from occurring within 100ms of the previous
        setTimeout(function(){ globalNavZoneRefreshed = false; }, 100);
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/ad-refresh/ad-refresh.js
// module id = 325
// module chunks = 36